import { DropdownOption } from '@aslanpay/portal-common-lib';
import { GroupWithPot } from 'app/hooks/useGroupsWithPot/types';
import { getGroupDisplayNameWithParents } from 'app/utils/groupsWithPot/groupsWithPot';

function formatOptionsForDropdown(groups: GroupWithPot[]): DropdownOption[] {
  const options: DropdownOption[] = groups.map((group) => ({
    text: getGroupDisplayNameWithParents(group),
    name: group.name,
    value: group.pot?.id || '',
    points: group.pot?.balance || 0,
    groupName: 'Pots',
  }));

  return options;
}

export { formatOptionsForDropdown };
